// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"_39upn6v","gameOverlayModal":"_1RPSL2I","mobile":"_3gteyNt"};